import { Component } from 'react';
import PropTypes from 'prop-types';
import { LazyImageWrapper } from '../../components/global/LazyImageWrapper';
import { TrackingSwiper } from '../../components/global/TrackingSwiper';
import {
    trackInitialDisplay,
    trackItemClick,
    trackRecentItems,
} from 'dibs-recent-history/exports/recentHistoryTracking';
import { SRC_SET_SIZES_RESP_RECENTLY_VIEWED_TILE } from '../../constants/imageConstants';
import { getSrcSetString } from 'dibs-search-product-tile/exports/srcSetHelpers';

class SharedRecentlyViewedItemsSwiper extends Component {
    constructor() {
        super();

        this.handleInitialDisplay = this.handleInitialDisplay.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    handleItemClick({ item, index }) {
        trackItemClick();
        trackRecentItems({
            type: 'productClick',
            items: [item],
            startIndex: index + 1, // Tracking needs non zero index position.
            variant: 'products',
        });
    }

    handleItemImpression({ item, index }) {
        trackRecentItems({
            type: 'productImpression',
            items: [item],
            startIndex: index + 1, // Tracking needs non zero index position.
            variant: 'products',
        });
    }

    handleInitialDisplay() {
        const { items } = this.props;
        const itemsReturned = items.length;
        trackInitialDisplay({ itemsReturned });
    }

    handlePageChange() {
        /*
         * Needed for lazy images to load on swipe event.
         */
        this.forceUpdate();
    }

    getCarouselItems() {
        const { items, classNames, offsetVertical, offsetHorizontal } = this.props;

        return items.map((item, index) => {
            const itemImageUrlSrc = item.itemImageUrl?.src || item.itemImageUrl;
            const srcSetAttributes = itemImageUrlSrc
                ? {
                      srcSet: getSrcSetString(itemImageUrlSrc),
                      sizes: SRC_SET_SIZES_RESP_RECENTLY_VIEWED_TILE,
                  }
                : {};

            return (
                <a
                    key={`recent-${item.itemId}`}
                    href={item.itemPdpUrl}
                    onClick={() => this.handleItemClick({ item, index })}
                >
                    <LazyImageWrapper
                        offsetHorizontal={offsetHorizontal}
                        offsetVertical={offsetVertical}
                        item={null}
                    >
                        <img
                            className={classNames.itemImage}
                            src={itemImageUrlSrc}
                            alt={item.itemTitle}
                            {...srcSetAttributes}
                        />
                    </LazyImageWrapper>
                </a>
            );
        });
    }

    render() {
        const { items, itemsPerPage } = this.props;

        return (
            <TrackingSwiper
                items={items}
                itemsPerPage={items.length < itemsPerPage ? items.length : itemsPerPage}
                classNames={this.props.classNames}
                onPageChange={this.handlePageChange}
                onItemImpression={this.handleItemImpression}
                onInitialDisplay={this.handleInitialDisplay}
            >
                {this.getCarouselItems()}
            </TrackingSwiper>
        );
    }
}

SharedRecentlyViewedItemsSwiper.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            contemporaryTrackingString: PropTypes.string,
            itemTitle: PropTypes.string.isRequired,
            itemId: PropTypes.string.isRequired,
            itemBrowseUrl: PropTypes.string,
            itemCategoryCode: PropTypes.string.isRequired,
            itemImageUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
            itemPdpUrl: PropTypes.string.isRequired,
            dealerPk: PropTypes.string.isRequired,
            category: PropTypes.string.isRequired,
        })
    ).isRequired,
    itemsPerPage: PropTypes.number.isRequired,
    classNames: PropTypes.shape({
        wrapper: PropTypes.string.isRequired,
        item: PropTypes.string.isRequired,
        placeholder: PropTypes.string.isRequired,
        itemImage: PropTypes.string.isRequired,
    }).isRequired,
    offsetVertical: PropTypes.number,
    offsetHorizontal: PropTypes.number,
};

export { SharedRecentlyViewedItemsSwiper };
